<template>
  <div>
    <div class="input-item">
      <div class="flex">
        <i class="login-icon i-phone"></i>
        <input
          name=""
          type="number"
          pattern="[0-9]*"
          placeholder="请输入手机号码"
          v-model="telInput"
          @onblur="blurInp()"
          v-on:input="validateTel"
        />
      </div>
      <p class="err-aux" v-show="isTelErrAux">*请输入11位正确格式的手机号码</p>
    </div>
    <div class="input-item" v-if="isStyle01 || isStyle03 || isStyle04 || isStyle05">
      <div class="flex">
        <i class="i-verf login-icon"></i>
        <input
          class="l"
          name=""
          type="number"
          pattern="[0-9]*"
          oninput="if(value.length>6)value=value.slice(0,6)"
          placeholder="请输入验证码"
          v-model="verfVal"
          @onblur="blurInp()"
          v-on:input="validateVerf"
        />
        <input
          type="button"
          class="vercode"
          :value="verfBtnVal"
          :disabled="isVerfBtnDisabled"
          @click="getVercode"
        />
      </div>
    </div>
    <div class="input-item" v-if="isStyle02 || isStyle03 || isStyle05 || isStyle06">
      <div class="flex">
        <i class="i-lock login-icon"></i>
        <input
          type="password"
          name=""
          placeholder="请输入密码"
          v-model="pswInput"
          @onblur="blurInp()"
          v-on:input="validatePsw1"
          v-show="!isPsw1Visible"
        />
        <input
          type="text"
          name=""
          placeholder="请输入密码"
          v-model="pswInput"
          @onblur="blurInp()"
          v-on:input="validatePsw1"
          v-show="isPsw1Visible"
        />
        <i
          class="login-icon"
          :class="{ 'i-eye-on': isPsw1Visible, 'i-eye-off': !isPsw1Visible }"
          @click="openEye1Click"
        ></i>
      </div>
      <p class="err-aux" v-show="isPswErrAux">*请输入6-20位数字与字母结合的密码</p>
      <!-- <p class="gray-aux" v-if="!isStyle05 && !isStyle06">
        *提示：第一次登录初始密码为您的手机号
      </p> -->
    </div>
    <div class="input-item" v-if="isStyle04">
      <div class="flex">
        <i class="i-lock login-icon"></i>
        <input
          type="password"
          name=""
          placeholder="请输入新密码"
          v-model="pswInput"
          @onblur="blurInp()"
          v-on:input="validatePsw1"
          v-show="!isPsw1Visible"
        />
        <input
          type="text"
          name=""
          placeholder="请输入新密码"
          v-model="pswInput"
          @onblur="blurInp()"
          v-on:input="validatePsw1"
          v-show="isPsw1Visible"
        />
        <i
          class="login-icon"
          :class="{ 'i-eye-on': isPsw1Visible, 'i-eye-off': !isPsw1Visible }"
          @click="openEye1Click"
        ></i>
      </div>
      <p class="err-aux" v-show="isPswErrAux">*请输入密码（6-20位数字与字母结合）</p>
    </div>
    <div class="input-item" v-if="isStyle03">
      <div class="flex">
        <i class="i-lock login-icon"></i>
        <input
          type="password"
          name=""
          placeholder="请确认密码"
          v-model="pswInput2"
          @onblur="blurInp()"
          v-on:input="validatePsw2"
          v-show="!isPsw2Visible"
        />
        <input
          type="text"
          name=""
          placeholder="请确认密码"
          v-model="pswInput2"
          @onblur="blurInp()"
          v-on:input="validatePsw2"
          v-show="isPsw2Visible"
        />
        <i
          class="login-icon"
          :class="{ 'i-eye-on': isPsw2Visible, 'i-eye-off': !isPsw2Visible }"
          @click="openEye2Click"
        ></i>
      </div>
      <p class="err-aux" v-show="isPswErrAux2">*两次输入密码不一致</p>
    </div>
    <div class="input-item" v-if="isStyle04">
      <div class="flex">
        <i class="i-lock login-icon"></i>
        <input
          type="password"
          name=""
          placeholder="请确认新密码"
          v-model="pswInput2"
          @onblur="blurInp()"
          v-on:input="validatePsw2"
          v-show="!isPsw2Visible"
        />
        <input
          type="text"
          name=""
          placeholder="请确认新密码"
          v-model="pswInput2"
          @onblur="blurInp()"
          v-on:input="validatePsw2"
          v-show="isPsw2Visible"
        />
        <i
          class="login-icon"
          :class="{ 'i-eye-on': isPsw2Visible, 'i-eye-off': !isPsw2Visible }"
          @click="openEye2Click"
        ></i>
      </div>
      <p class="err-aux" v-show="isPswErrAux2">*两次输入密码不一致</p>
    </div>
    <!-- 注册 -->
    <div class="input-item" v-if="isStyle05">
      <div class="flex">
        <i class="login-icon i-name"></i>
        <input
          name=""
          type="text"
          placeholder="请输入真实姓名"
          v-model="nameInput"
          @onblur="blurInp()"
        />
      </div>
      <p class="err-aux" v-show="isNameErrAux">*务必和身份证上保持一致</p>
    </div>
    <div class="input-item" v-if="isStyle05">
      <div class="flex">
        <i class="login-icon i-idcad"></i>
        <input
          name=""
          placeholder="请输入身份证号"
          autocomplete="off"
          maxlength="18"
          @input="inputChange"
          v-model="idCardInput"
          @onblur="blurInp()"
          onkeyup="value=value.replace(/[^\X0-9]/g, '')"
        />
      </div>
      <p class="err-aux" v-show="isidCardInputErrAux">
        *用来进行实名认证和在线签订合同,务必和身份证上保持一致
      </p>
    </div>
    <div class="input-item" v-if="isStyle05">
      <div class="flex">
        <i class="login-icon i-sex"></i>
        <input
          style="border: 0px; outline: none; background-color: #fff"
          disabled
          name=""
          placeholder="性别"
          v-model="sex"
          @onblur="blurInp()"
          onkeyup="value=value.replace(/[^\X0-9]/g, '')"
        />
      </div>
    </div>
    <button
      type="button"
      class="btn-l"
      :disabled="isSubmitDisabledC || isSubmitDisabledF"
      @click="submit"
      v-text="btnText"
    ></button>
  </div>
</template>

<script>
import {
  blurInp,
  telreg,
  pswReg,
  letterNumber,
  testExpress,
  cardreg,
} from "common/utils";
import { getVerf } from "network/login";
export default {
  name: "LoginForm",
  props: {
    btnText: {
      type: String,
      default: "登录",
    },
    isStyle01: {
      //验证码登录
      type: Boolean,
      default: false,
    },
    isStyle02: {
      //密码登录登录
      type: Boolean,
      default: false,
    },
    isStyle03: {
      //注册
      type: Boolean,
      default: false,
    },
    isStyle04: {
      //找回密码 修改密码
      type: Boolean,
      default: false,
    },
    isStyle05: {
      //注册
      type: Boolean,
      default: false,
    },
    isStyle06: {
      //维修人员登录
      type: Boolean,
      default: false,
    },
    // 登录页面，无需校验密码
    isLogin: {
      type: Boolean,
      default: false,
    },
    isRegister: {
      type: Boolean,
      default: false,
    },
    isSubmitDisabledF: Boolean,
  },
  data() {
    return {
      telInput: "", //13294152966
      isTelErrAux: false,
      verfVal: "",
      verfBtnVal: "发送验证码",
      isVerfBtnDisabled: true,
      intervalId2: null,
      pswInput: "", //6-20位数字与字母结合
      isPswErrAux: false,
      pswInput2: "",
      lock: false, // 获取验证码按钮锁
      isSubmitDisabled: true,
      isPsw1Visible: false,
      isPsw2Visible: false,
      nameInput: "",
      isNameErrAux: false,
      idCardInput: "",
      isidCardInputErrAux: false,
      sex: "",
    };
  },
  created() {},
  watch: {
    // 电话号码
    telInput: {
      handler(newVal) {
        const isTrue = telreg.test(newVal);
        if (isTrue) {
          this.isTelErrAux = false;
          if (this.lock) {
            this.isVerfBtnDisabled = true;
          } else {
            this.isVerfBtnDisabled = false;
          }
        } else {
          if (newVal.length === 0) {
            this.isTelErrAux = false;
          } else {
            this.isTelErrAux = true;
          }
          this.isVerfBtnDisabled = true;
        }
      },
      deep: true,
      immediate: true,
    },
    // 密码
    pswInput(newVal) {
      // console.log(letterNumber.test(newVal));
      if (letterNumber.test(newVal) == false || newVal.length === 0) {
        // 登录页面无需校验密码
        if (this.isLogin) {
          this.isPswErrAux = false;
        } else {
          this.isPswErrAux = true;
        }
      } else {
        this.isPswErrAux = false;
      }
    },
    //姓名
    nameInput: {
      handler(newVal) {
        const isTrue = testExpress.test(newVal);
        if (isTrue) {
          this.isNameErrAux = false;
        } else {
          if (newVal.length === 0) {
            this.isNameErrAux = false;
          } else {
            this.isNameErrAux = true;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    //身份证
    idCardInput: {
      handler(newVal) {
        const isTrue = cardreg.test(newVal);
        if (isTrue) {
          this.isidCardInputErrAux = false;
        } else {
          if (newVal.length === 0) {
            this.isidCardInputErrAux = false;
          } else {
            this.isidCardInputErrAux = true;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 两次密码输入是否一致
    isPswErrAux2() {
      if (this.pswInput2.length >= 1 && this.pswInput !== this.pswInput2) {
        return true;
      } else {
        return false;
      }
    },
    // 提交按钮
    isSubmitDisabledC() {
      if (this.isStyle03) {
        // 样式03：手机号码、验证码、密码、密码确认
        if (
          telreg.test(this.telInput) &&
          this.verfVal.length > 0 &&
          letterNumber.test(this.pswInput) == true &&
          this.pswInput2 === this.pswInput
        ) {
          return false;
        } else {
          return true;
        }
      } else if (this.isStyle01) {
        // 样式01：手机号码、验证码 验证码登录页
        if (telreg.test(this.telInput) && this.verfVal.length > 0) {
          return false;
        } else {
          return true;
        }
      } else if (this.isStyle02) {
        // 样式02：手机号码、密码  密码登录页
        if (telreg.test(this.telInput) && letterNumber.test(this.pswInput) == true) {
          return false;
        } else {
          // 登录页面,当用户已输入账号密码，登录按钮解除禁用状态
          if (this.isLogin && telreg.test(this.telInput) && this.pswInput) {
            return false;
          } else {
            return true;
          }
        }
      } else if (this.isStyle04) {
        // 样式04：手机号码、验证码 找回密码页
        if (
          telreg.test(this.telInput) &&
          this.verfVal.length > 0 &&
          letterNumber.test(this.pswInput) == true &&
          this.pswInput2 === this.pswInput
        ) {
          return false;
        } else {
          return true;
        }
      } else if (this.isStyle05) {
        // 样式05：注册页
        if (
          telreg.test(this.telInput) &&
          this.verfVal.length > 0 &&
          letterNumber.test(this.pswInput) == true &&
          testExpress.test(this.nameInput) &&
          cardreg.test(this.idCardInput)
        ) {
          return false;
        } else {
          return true;
        }
      } else if (this.isStyle06) {
        // 样式06：手机号码、密码  - 维修人员登录
        if (telreg.test(this.telInput) && letterNumber.test(this.pswInput) == true) {
          return false;
        } else {
          // 登录页面,当用户已输入账号密码，登录按钮解除禁用状态
          if (telreg.test(this.telInput) && this.pswInput) {
            return false;
          } else {
            return true;
          }
        }
      }
    },
  },
  beforeDestroy() {
    // 清除60s倒计时定时器
    window.clearInterval(this.intervalId2);
  },
  methods: {
    // 检验身份证号
    inputChange() {
      const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (reg.test(this.idCardInput)) {
        var org_gender = this.idCardInput.substring(16, 17);
        var sex = org_gender % 2 == 1 ? "男" : "女";

        this.sex = sex;
      } else {
        this.sex = "识别中";
        return false;
      }
    },
    // 60s倒计时
    async getVercode() {
      const result = await getVerf(this.telInput, this.isRegister);
      console.log(result);
      if (result && result.data && result.data.code === 1) {
        this.$toast.show("发送成功，请注意查看手机短信！", 1500);
        let verNum = 60;
        this.isVerfBtnDisabled = true;
        this.lock = true;
        this.verfBtnVal = verNum + "s后重试";
        const that = this;
        that.intervalId2 = setInterval(() => {
          if (verNum < 1) {
            this.lock = false;
            if (telreg.test(this.telInput)) {
              that.isVerfBtnDisabled = false;
            }
            that.verfBtnVal = "获取验证码";
            window.clearInterval(that.intervalId2);
            that.intervalId2 = null;
            return false;
          }
          // 每秒减1
          verNum--;
          // 赋值
          that.verfBtnVal = verNum + "s后重试";
        }, 1000);
      } else {
        this.$toast.show(result.data.message, 1500);
      }
    },
    // 提交数据
    submit() {
      let val = {
        telInput: this.telInput,
        verfVal: this.verfVal,
        pswInput: this.pswInput,
        pswInput2: this.pswInput2,
        nameInput: this.nameInput,
        idCardInput: this.idCardInput,
      };
      this.$emit("submit", val);
    },
    // 密码可见/不可见切换
    openEye1Click() {
      this.isPsw1Visible = !this.isPsw1Visible;
    },
    // 密码2可见/不可见切换
    openEye2Click() {
      this.isPsw2Visible = !this.isPsw2Visible;
    },
    // 密码输入格式校验
    validatePsw1(val) {
      if (this.pswInput.length > 20) {
        this.pswInput = this.pswInput.trim().slice(0, 20);
      }
    },
    // 密码输入格式校验
    validatePsw2() {
      if (this.pswInput2.length > 20) {
        this.pswInput2 = this.pswInput2.trim().slice(0, 20);
      }
    },
    // 手机号码输入校验：只能输入11位数字
    validateTel() {
      this.telInput = this.telInput.replace(/[^\d]/g, "");
      if (this.telInput.length > 11) {
        this.telInput = this.telInput.trim().slice(0, 11);
      }
    },
    // 验证码输入校验：只能输入数字
    validateVerf() {
      this.verfVal = this.verfVal.trim().replace(/[^\d]/g, "");
    },
  },
};
</script>

<style scoped src="../login_style.css"></style>
